(function () {
  'use strict';

  const QHCartDrawer = {
    init() {
      this.cache();
      this.bind();
      this.fetchCart(false);
    },

    cache() {
      this.drawer = document.querySelector('[data-qh-cart-drawer]');
      this.items = this.drawer ? this.drawer.querySelector('[data-qh-cart-items]') : null;
      this.footer = this.drawer ? this.drawer.querySelector('[data-qh-cart-footer]') : null;
      this.subtotal = this.drawer ? this.drawer.querySelector('[data-qh-cart-subtotal]') : null;
      this.cart = null;
      this.isLoading = false;
      this.openTimer = null;
    },

    bind() {
      document.addEventListener('qh:cart:open', () => this.open(true));

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-qh-cart-trigger]');
        const close = event.target.closest('[data-qh-cart-close]');
        const minus = event.target.closest('[data-qh-qty-minus]');
        const plus = event.target.closest('[data-qh-qty-plus]');
        const remove = event.target.closest('[data-qh-item-remove]');

        if (trigger) {
          event.preventDefault();
          this.open(true);
          return;
        }

        if (close) {
          event.preventDefault();
          this.close();
          return;
        }

        if (minus) {
          event.preventDefault();
          this.updateQuantity(minus.dataset.itemKey, -1);
          return;
        }

        if (plus) {
          event.preventDefault();
          this.updateQuantity(plus.dataset.itemKey, 1);
          return;
        }

        if (remove) {
          event.preventDefault();
          this.changeItem(remove.dataset.itemKey, 0);
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });

      document.addEventListener('submit', (event) => {
        const form = event.target;
        if (!form || !form.matches('form[action*="/cart/add"]')) return;
        this.scheduleOpen();
      }, true);

      document.addEventListener('cart:updated', (event) => {
        if (event.detail && typeof event.detail.item_count !== 'undefined') {
          this.cart = event.detail;
          this.render(event.detail);
        } else {
          this.fetchCart(false);
        }
      });
    },

    scheduleOpen() {
      clearTimeout(this.openTimer);
      this.openTimer = setTimeout(() => this.open(true), 650);
    },

    open(shouldFetch) {
      if (!this.drawer) return;
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (shouldFetch) this.fetchCart(false);
    },

    close() {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },

    fetchCart(openAfter) {
      if (this.isLoading) return Promise.resolve(this.cart);
      this.isLoading = true;

      return fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      })
        .then((response) => response.json())
        .then((cart) => {
          this.cart = cart;
          this.render(cart);
          if (openAfter) this.open(false);
          return cart;
        })
        .catch((error) => {
          console.error('QH cart error:', error);
          return null;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    findItem(key) {
      if (!this.cart || !Array.isArray(this.cart.items)) return null;
      return this.cart.items.find((item) => item.key === key);
    },

    updateQuantity(key, diff) {
      const item = this.findItem(key);
      if (!item) return;
      const nextQty = item.quantity + diff;
      this.changeItem(key, nextQty < 1 ? 0 : nextQty);
    },

    changeItem(key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: key, quantity })
      })
        .then((response) => {
          if (!response.ok) throw new Error('Cart update failed');
          return response.json();
        })
        .then((cart) => {
          this.cart = cart;
          this.render(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          return cart;
        })
        .catch((error) => {
          console.error('QH cart update error:', error);
          return null;
        });
    },

    render(cart) {
      if (!cart || !this.items) return;
      this.updateCounts(cart.item_count);

      if (!cart.item_count) {
        this.items.innerHTML = this.emptyHtml();
        if (this.footer) this.footer.hidden = true;
        return;
      }

      this.items.innerHTML = cart.items.map((item) => this.itemHtml(item)).join('');
      if (this.footer) this.footer.hidden = false;
      if (this.subtotal) this.subtotal.textContent = this.formatMoney(cart.total_price);
    },

    updateCounts(count) {
      document.querySelectorAll('[data-header-cart-count], .qh-header__count').forEach((el) => {
        el.textContent = count;
        el.style.display = count > 0 ? 'inline-flex' : 'none';
      });
    },

    itemHtml(item) {
      const image = item.image
        ? `<img src="${item.image}" alt="${this.escapeHtml(item.product_title)}" width="80" height="80" loading="lazy">`
        : '<div class="qh-cart-drawer__image-placeholder"></div>';
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="qh-cart-drawer__variant">${this.escapeHtml(item.variant_title)}</p>`
        : '';

      return `
        <article class="qh-cart-drawer__item" data-qh-cart-item data-item-key="${this.escapeHtml(item.key)}">
          <a class="qh-cart-drawer__image" href="${this.escapeHtml(item.url)}">${image}</a>
          <div class="qh-cart-drawer__item-info">
            <a class="qh-cart-drawer__item-title" href="${this.escapeHtml(item.url)}">${this.escapeHtml(item.product_title)}</a>
            ${variant}
            <div class="qh-cart-drawer__item-bottom">
              <div class="qh-cart-drawer__qty">
                <button type="button" data-qh-qty-minus data-item-key="${this.escapeHtml(item.key)}" aria-label="Restar cantidad">-</button>
                <span>${item.quantity}</span>
                <button type="button" data-qh-qty-plus data-item-key="${this.escapeHtml(item.key)}" aria-label="Sumar cantidad">+</button>
              </div>
              <span class="qh-cart-drawer__price">${this.formatMoney(item.final_line_price)}</span>
            </div>
          </div>
          <button type="button" class="qh-cart-drawer__remove" data-qh-item-remove data-item-key="${this.escapeHtml(item.key)}" aria-label="Eliminar item">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M4 7h16M10 11v6M14 11v6M6 7l1 15h10l1-15M9 7V4h6v3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </article>
      `;
    },

    emptyHtml() {
      return `
        <div class="qh-cart-drawer__empty">
          <p>Tu carrito esta vacio</p>
          <a href="/collections/quiero-home?sort_by=best-selling">Ver productos</a>
        </div>
      `;
    },

    formatMoney(cents) {
      const amount = Number(cents || 0) / 100;
      return '$ ' + amount.toLocaleString('es-UY', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    },

    escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => QHCartDrawer.init());
  } else {
    QHCartDrawer.init();
  }
})();
